import React from 'react';
import { SearchableSelect } from '../components';
import { KAToggle } from './kaControls';

const EMPTY = '__empty__';
const kindLabel = { text: '文本', option: '单选', multi_option: '多选' };

export function ExtendedFieldSettings({ fields, value = [], onChange, disabled }) {
  const selected = new Set(value.map(entry => entry.field_id));
  const options = fields.filter(field => field.extended_kind && (field.is_active !== false || selected.has(field.id)))
    .map(field => ({ value: field.id, label: `${field.name} (${field.id})` }));
  // Retain deleted/unsupported selections so they can be removed explicitly.
  value.forEach(entry => {
    if (!options.some(option => option.value === entry.field_id)) options.push({ value: entry.field_id, label: `${entry.field_id}（字段不可用，请移除）` });
  });
  const update = (id, key, checked) => onChange(value.map(entry => entry.field_id === id ? { ...entry, [key]: checked } : entry));
  return <section className="ka-field-config-section">
    <h4>KA 扩展字段</h4>
    <p>从字段管理选择最多 20 个文本或选项字段。选中即采集，可分别开启筛选与列表展示；保存后需手动重新汇总。</p>
    <div className="ka-control" role="group" aria-label="扩展采集字段"><span>扩展采集字段</span>
      <SearchableSelect multiple value={value.map(entry => entry.field_id)} options={options} disabled={disabled}
        placeholder="选择需要采集的字段" onChange={ids => onChange(ids.map(field_id => value.find(entry => entry.field_id === field_id) || { field_id, show_filter: true, show_column: true }))} />
    </div>
    {value.map(entry => {
      const field = fields.find(item => item.id === entry.field_id);
      const name = field?.name || entry.field_id;
      return <div className="ka-extended-setting" key={entry.field_id}>
        <div><strong>{name}</strong><small className="ka-muted">{entry.field_id} · {kindLabel[field?.extended_kind] || '字段不可用'}</small></div>
        <KAToggle label={`${name}显示筛选`} help="在 KA 看板增加该字段的筛选条件。" checked={entry.show_filter} disabled={disabled} onChange={checked => update(entry.field_id, 'show_filter', checked)} />
        <KAToggle label={`${name}显示在列表`} help="在工单明细和状态下钻列表中展示该字段。" checked={entry.show_column} disabled={disabled} onChange={checked => update(entry.field_id, 'show_column', checked)} />
      </div>;
    })}
  </section>;
}

export function extendedFilterParams(value = {}) {
  const conditions = Object.fromEntries(Object.entries(value).filter(([, condition]) => condition.empty || condition.values?.length || condition.text));
  return Object.keys(conditions).length ? { extended: JSON.stringify(conditions) } : {};
}

export function ExtendedFilters({ fields = [], value = {}, onChange }) {
  const update = (field, condition) => {
    const next = { ...value };
    if (condition) next[field] = condition;
    else delete next[field];
    onChange(next);
  };
  return fields.filter(field => field.show_filter).map(field => {
    const condition = value[field.field_id] || {};
    if (field.kind === 'text') {
      const mode = condition.empty ? 'empty' : 'text' in condition ? 'text' : '';
      return <div className="ka-control" key={field.field_id}><label>{field.name}
        <select aria-label={`${field.name}筛选方式`} value={mode} onChange={event => update(field.field_id, event.target.value === 'empty' ? { empty: true } : event.target.value === 'text' ? { text: '' } : null)}>
          <option value="">全部</option><option value="text">包含关键词</option><option value="empty">未填写</option>
        </select></label>
        {mode === 'text' && <input aria-label={`${field.name}关键词`} maxLength={200} value={condition.text || ''} placeholder="输入关键词" onChange={event => update(field.field_id, { text: event.target.value })} />}
      </div>;
    }
    return <div className="ka-control" role="group" aria-label={field.name} key={field.field_id}><span>{field.name}</span>
      <SearchableSelect multiple clearable clearLabel={`清空${field.name}`} placeholder="全部" value={[...(condition.values || []), ...(condition.empty ? [EMPTY] : [])]}
        options={[{ value: EMPTY, label: '未填写' }, ...(field.options || []).map(option => ({ value: option.token, label: option.label }))]}
        onChange={tokens => {
          const values = tokens.filter(token => token !== EMPTY);
          update(field.field_id, tokens.length ? { ...(values.length ? { values } : {}), ...(tokens.includes(EMPTY) ? { empty: true } : {}) } : null);
        }} />
    </div>;
  });
}

export function ExtendedHeaders({ fields = [] }) {
  return fields.filter(field => field.show_column).map(field => <th key={field.field_id}>{field.name}</th>);
}

export function ExtendedCells({ fields = [], issue }) {
  return fields.filter(field => field.show_column).map(field => {
    const value = issue.extended_values?.[field.field_id];
    const text = value == null ? '未采集' : Array.isArray(value) ? value.map(option => option.label).join('、') || '未填写' : value || '未填写';
    return <td className="ka-extended-cell" key={field.field_id}>{text}</td>;
  });
}
